<div class="dashboard-shell" [class.quote-add-screen]="isQuoteAddScreen" [class.quote-compact-scale]="useCompactQuoteScale">
  @if (dashboardNavItems.length > 0) {
    <nav class="dashboard-block-nav" aria-label="Dashboard sections">
      @for (navItem of dashboardNavItems; track $index) {
        <a
          class="dashboard-nav-block"
          [routerLink]="navItem.route"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          {{ navItem.label }}
        </a>
      }
    </nav>
  }

  <div class="dashboard-content-area">
    @if(!!configurations?.filters) {
    <app-global-filter [config]="configurations?.filters"></app-global-filter>
    }

    <div>
      @for (item of configurations?.pageContent; track $index) {
        <div class="row">
          @if (item?.title?.trim()) {
            <h4 class="title">{{ item?.title }}</h4>
          }

          @for (column of item?.columns; track $index) {
            <div class="col {{ column?.class }}">
              <!-- If column is a widget -->
              @if (column?.type) {
                <app-widget-renderer [charts]="column" (editRecord)="onEditRecord($event)"></app-widget-renderer>
              }

              <!-- Nested rows inside column -->
              @if (column?.rows?.length > 0) {
                @for (nestedItem of column.rows; track $index) {
                  
                  <!-- If nestedItem is a widget (has type) -->
                  @if(nestedItem?.type) {
                    <div class="col {{ nestedItem?.class }}">
                      <app-widget-renderer [charts]="nestedItem" (editRecord)="onEditRecord($event)"></app-widget-renderer>
                    </div>
                  }

                  <!-- If nestedItem is a row (has columns) -->
                  @if(nestedItem?.columns?.length > 0) {
                    <div class="row">
                      @if (nestedItem?.title?.trim()) {
                        <h4 class="title">{{ nestedItem?.title }}</h4>
                      }
                      @for (nestedCol of nestedItem.columns; track $index) {
                        <div class="col {{ nestedCol?.class }}">
                          <app-widget-renderer [charts]="nestedCol" (editRecord)="onEditRecord($event)"></app-widget-renderer>
                        </div>
                      }
                    </div>
                  }
                }
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>

<!-- Edit Dialog -->
@if(showEditDialog && editRecordData) {
<div class="edit-dialog-overlay" (click)="closeEditDialog()">
  <div class="edit-dialog" (click)="$event.stopPropagation()">
    <div class="edit-dialog-header">
      <h3>Edit Record</h3>
      <button class="close-btn" (click)="closeEditDialog()">×</button>
    </div>
    <div class="edit-dialog-body">
      <table class="edit-table">
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          @for (key of objectKeys(editRecordData); track key) {
            <tr>
              <td>{{ key }}</td>
              <td>
                <input type="text" [(ngModel)]="editRecordData[key]" />
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="edit-dialog-footer">
      <button class="save-btn" (click)="saveEdit()">Save</button>
      <button class="cancel-btn" (click)="closeEditDialog()">Cancel</button>
    </div>
  </div>
</div>
}
